import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchSharedBoard } from "../Boards/api/boardApi";
import { CellRenderer } from "../Boards/components/cells";
import "../Boards/board.scss";

// Public read-only board viewer. No auth required; fetches the board via
// the /share/:token endpoint. Renders a stripped-down table view — no
// toolbar, no add buttons, no item drawer.
export default function SharedBoard() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, error: null, data: null });

  useEffect(() => {
    fetchSharedBoard(token)
      .then((res) => setState({ loading: false, error: null, data: res.data }))
      .catch((e) => setState({ loading: false, error: e.message || "Could not load", data: null }));
  }, [token]);

  if (state.loading) return <div className="shared-board-loading">Loading shared board…</div>;
  if (state.error) {
    return (
      <div className="shared-board-error">
        <h2>Unable to open this link</h2>
        <p>{state.error}</p>
      </div>
    );
  }

  const { board, items } = state.data;
  const columns = (board.columns || []).slice().sort((a, b) => a.order - b.order);
  const groups = (board.groups || []).slice().sort((a, b) => a.order - b.order);

  const itemsByGroup = {};
  for (const g of groups) itemsByGroup[g._id] = [];
  for (const it of items) {
    if (!itemsByGroup[it.group_id]) itemsByGroup[it.group_id] = [];
    itemsByGroup[it.group_id].push(it);
  }

  return (
    <div className="shared-board-page">
      <header className="shared-head">
        <h2>{board.name}</h2>
        <span className="shared-tag">Read-only shared view</span>
      </header>

      <div className="board-page">
        <div className="board-table-wrap">
          {groups.map((g) => (
            <section key={g._id} className="group-block">
              <header className="group-head" style={{ borderLeftColor: g.color }}>
                <span className="group-title">{g.title}</span>
                <span className="group-count">{(itemsByGroup[g._id] || []).length} items</span>
              </header>
              <table className="board-table">
                <thead>
                  <tr>
                    <th className="col-title">Item</th>
                    {columns.map((c) => <th key={c._id} className="col-head"><span>{c.title}</span></th>)}
                    <th className="col-end" />
                  </tr>
                </thead>
                <tbody>
                  {(itemsByGroup[g._id] || []).map((it) => (
                    <tr key={it._id} className={`item-row kind-${it.kind || "task"}`}>
                      <td className="cell title-cell">
                        <div className="title-row">
                          <span className="title-text">{it.title}</span>
                        </div>
                      </td>
                      {columns.map((c) => (
                        <td key={c._id} className={`cell type-${c.type}`}>
                          <CellRenderer
                            column={c}
                            value={it.column_values?.[c._id]?.value ?? null}
                            readOnly
                            peopleIndex={{}}
                            allPeople={[]}
                            item={it}
                            boardId={board._id}
                            onCommit={() => undefined}
                          />
                        </td>
                      ))}
                      <td className="cell col-end" />
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
